import { atomWithReset } from 'jotai/utils';

export type FeedTab =
  | 'allArticles'
  | 'businessOpportunity'
  | 'materials'
  | 'spotlight'
  | 'trends';

export const feedActiveTabState = atomWithReset<FeedTab>('allArticles');
